var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7802_61877",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7802_61877)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_7802_61877",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.71504 17.183L4.57466e-05 22.9938L0.871034 23.7274L9.9501 19.1708L2.71504 17.183Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.71504 17.183L4.57466e-05 22.9938L0.871034 23.7274L9.9501 19.1708L2.71504 17.183Z",
    fill: "#4611A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.71504 17.183L3.04142 15.9951L2.03898 15.7197L1.59891 16.6615L2.71504 17.183ZM4.57466e-05 22.9938L-1.11608 22.4723L-1.51579 23.3278L-0.79357 23.936L4.57466e-05 22.9938ZM0.871034 23.7274L0.077419 24.6696L0.698218 25.1925L1.42363 24.8284L0.871034 23.7274ZM9.9501 19.1708L10.5027 20.2718L13.37 18.8328L10.2765 17.9828L9.9501 19.1708ZM1.59891 16.6615L-1.11608 22.4723L1.11617 23.5153L3.83117 17.7045L1.59891 16.6615ZM-0.79357 23.936L0.077419 24.6696L1.66465 22.7851L0.793661 22.0515L-0.79357 23.936ZM1.42363 24.8284L10.5027 20.2718L9.3975 18.0697L0.318436 22.6263L1.42363 24.8284ZM10.2765 17.9828L3.04142 15.9951L2.38867 18.3709L9.62372 20.3587L10.2765 17.9828Z",
    fill: "#666666",
    mask: "url(#path-2-inside-1_7802_61877)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3499 11.5407C23.3499 17.5555 18.4739 22.4314 12.4592 22.4314C6.44439 22.4314 1.56846 17.5555 1.56846 11.5407C1.56846 5.52594 6.44439 0.65 12.4592 0.65C18.4739 0.65 23.3499 5.52594 23.3499 11.5407Z",
    fill: "white",
    stroke: "#666666",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.30497,
    cy: 11.5406,
    rx: 2.30814,
    ry: 2.30814,
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.4599,
    cy: 11.5406,
    rx: 2.30814,
    ry: 2.30814,
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.6154,
    cy: 11.5406,
    rx: 2.30814,
    ry: 2.30814,
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.08984 17C4.65065 17.7588 5.77367 18.8995 6.5 19.5L3 21.5L1.5 22.338L4.08984 17Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.b0cc73fcff32b3db225d5a2273756587.svg";
export { ForwardRef as ReactComponent };